const STORE_ID_PATTERN = /^[A-Z0-9]{12}$/i;

/**
 * Accepts a 12-character Microsoft Store Product ID, or any `apps.microsoft.com`
 * URL that embeds one, and returns the canonical upper-case Product ID. Returns
 * `null` if the input cannot be resolved to a valid Store ID.
 */
export function normalizeMicrosoftStoreId(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (STORE_ID_PATTERN.test(trimmed)) {
    return trimmed.toUpperCase();
  }

  try {
    const url = new URL(trimmed);
    const queryStoreId =
      url.searchParams.get('ProductId') ??
      url.searchParams.get('productId') ??
      url.searchParams.get('id');

    if (queryStoreId && STORE_ID_PATTERN.test(queryStoreId)) {
      return queryStoreId.toUpperCase();
    }

    const pathSegments = url.pathname.split('/').filter(Boolean);
    for (const segment of pathSegments.reverse()) {
      if (STORE_ID_PATTERN.test(segment)) {
        return segment.toUpperCase();
      }
    }
  } catch {
    return null;
  }

  return null;
}

export function normalizeOutboundUrl(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  try {
    return new URL(trimmed).toString();
  } catch {
    return null;
  }
}

export function getMicrosoftStoreDetailUrl(storeId: string): string {
  return `https://apps.microsoft.com/detail/${storeId}`;
}

export function getMicrosoftStoreReviewUrl(storeId: string): string {
  return `ms-windows-store://review/?ProductId=${storeId}`;
}
